import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.array.sort.js";
import Markdown from "../components/Markdown";
import dsteem from "../unit/DsteemUtil";
import Comment from "../components/Comment/Comment";
import ReSteem from "../components/PostComponents/ReSteem";
import PostFootFunction from "../components/PostComponents/PostFootFunction";
import { extractLoginData, getAccount, getAccountReputation as gar } from "../unit/UserUtil";
import { getImgFromStr, getDateTimeStamp, getDateDiff } from "../unit/public";
export default {
  components: {
    Markdown: Markdown,
    Comment: Comment,
    ReSteem: ReSteem,
    PostFootFunction: PostFootFunction
  },
  data: function data() {
    return {
      blog: {},
      body: "",
      userName: null,
      permlink: null,
      loginData: null,
      currentUser: {},
      data: [],
      replies: [],
      community: null,
      rootPost: {},
      props: {
        id: "_id",
        content: "content",
        imgSrc: "imgSrc",
        children: "childrenComments",
        likes: "likes",
        liked: "liked",
        reply: "reply",
        createAt: "createAt",
        user: "visitor",
        voters: "voters"
      },
      likeid: "",
      isAuthor: false,
      tags: "",
      recommendedBlogs: []
    };
  },
  methods: {
    submit: function submit(newComment, parent, add) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve({
                      newComment: newComment,
                      parent: parent
                    });
                  }, 300);
                });

              case 2:
                res = _context.sent;
                add(Object.assign(res.newComment, {
                  _id: new Date().getTime()
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    like: function like(comment) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve(comment);
                  }, 0);
                });

              case 2:
                res = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getAccountReputation: function getAccountReputation(input) {
      return gar(input);
    },
    dateDiff: function dateDiff(dateTime) {
      if (dateTime) {
        dateTime = dateTime.replace("T", " ");
        return getDateDiff(getDateTimeStamp(dateTime));
      }
    },
    buildArticleUrl: function buildArticleUrl(item) {
      return "/".concat(item.community, "/@").concat(item.author, "/").concat(item.permlink);
    },
    getRecommendImage: function getRecommendImage(item) {
      var image = getImgFromStr(item.json_metadata, item.body);
      return image || "/img/brand/DefaultPost.png";
    },
    loadRecommendedBlogs: function loadRecommendedBlogs() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var blogs;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return dsteem.getBlogsByBridge(_this.loginData ? _this.loginData[0] : null, "trending", _this.community, 8);

              case 3:
                blogs = _context3.sent;
                _this.recommendedBlogs = (blogs || []).filter(function (item) {
                  return item.author !== _this.userName || item.permlink !== _this.permlink;
                }).slice(0, 6);
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                _this.recommendedBlogs = [];

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 7]]);
      }))();
    },
    loadSubComments: function loadSubComments(currentComment, childrenComments, replies, content) {
      var _this2 = this;

      for (var i in replies) {
        var c = content[replies[i]];
        var comment = {};
        comment._id = c.post_id;
        comment.content = c.body;
        comment._id = c.post_id;
        comment.visitor = {
          name: c.author,
          avatar: "https://steemitimages.com/u/" + c.author + "/avatar",
          permlink: c.permlink
        };
        comment.createAt = c.created;
        comment.likes = c.active_votes.length;
        comment.voters = c.active_votes;
        comment.liked = c.active_votes.filter(function (item) {
          return item.voter === _this2.currentUser.name && parseFloat(item.percent) >= 0;
        }).length >= 1;
        comment.reply = {
          name: currentComment.visitor.name
        };
        this.loadSubComments(comment, childrenComments, c.replies, content);
        childrenComments.push(comment);
      }

      return childrenComments;
    },
    loadAccount: function loadAccount() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var account;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.loginData = extractLoginData();

                if (!_this3.loginData) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 4;
                return getAccount(_this3.loginData[0]);

              case 4:
                account = _context4.sent;
                _this3.currentUser.name = _this3.loginData[0];
                _this3.currentUser.avatar = account.profile_image;
                _this3.isAuthor = _this3.currentUser.name == _this3.userName;

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    loadAuthorAccount: function loadAuthorAccount() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var account, script;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return getAccount(_this4.$route.params.username.replace("@", ""));

              case 2:
                account = _context5.sent;
                _this4.likeid = account.likeid;
                script = document.createElement("script");
                script.type = "text/javascript";
                script.src = "https://static.like.co/sdk/v1/button.js";
                document.body.appendChild(script);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    getComment: function getComment() {
      var comments = [];
      var that = this;
      dsteem.getState(this.community + "/@" + this.userName + "/" + this.permlink).then(function (result) {
        for (var i in result.content) {
          var comment = {};
          var c = result.content[i];

          if (c.depth == 1) {
            comment._id = c.post_id;
            comment.content = c.body;
            comment.visitor = {
              name: c.author,
              avatar: "https://steemitimages.com/u/" + c.author + "/avatar",
              permlink: c.permlink
            };
            comment.createAt = c.created;
            comment.likes = c.active_votes.length;
            comment.voters = c.active_votes;
            comment.liked = c.active_votes.filter(function (item) {
              return item.voter === that.currentUser.name && parseFloat(item.percent) >= 0;
            }).length >= 1;
            var childrenComments = [];
            childrenComments = that.loadSubComments(comment, childrenComments, c.replies, result.content);
            childrenComments.sort(function (x, y) {
              return y.createAt < x.createAt ? 1 : -1;
            });
            comment.childrenComments = childrenComments;
            comments.push(comment);
          }
        }

        comments.sort(function (x, y) {
          return y.createAt < x.createAt ? 1 : -1;
        });
        that.data = comments;
        that.replies = result;
      });
    }
  },
  created: function created() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var retryNum, profile;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this5.userName = _this5.$route.params.username.replace("@", "");
              _this5.permlink = _this5.$route.params.permlink;
              _this5.community = _this5.$route.params.community;
              _this5.rootPost.parent_author = _this5.userName;
              _this5.rootPost.permlink = _this5.permlink;
              retryNum = 0;

            case 6:
              if (!(retryNum < 20)) {
                _context6.next = 19;
                break;
              }

              _context6.prev = 7;
              _context6.next = 10;
              return dsteem.getPostDetailsByBridge(_this5.userName, _this5.permlink);

            case 10:
              _this5.blog = _context6.sent;

              if (!_this5.blog) {
                _context6.next = 13;
                break;
              }

              return _context6.abrupt("break", 19);

            case 13:
              _context6.next = 17;
              break;

            case 15:
              _context6.prev = 15;
              _context6.t0 = _context6["catch"](7);

            case 17:
              _context6.next = 6;
              break;

            case 19:
              profile = _this5.blog.json_metadata;
              _this5.tags = profile.tags;

              _this5.loadAccount();

              _this5.$bus.on("loginScuccess", function () {
                _this5.loadAccount();
              });

              _this5.$bus.on("logout", function () {
                _this5.currentUser = {};
              });

              _this5.getComment();

              _this5.loadAuthorAccount();

              _this5.loadRecommendedBlogs();

            case 27:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[7, 15]]);
    }))();
  }
};